<template>
  <div class="observations">
    <div
      class="submissions-app observation-list"
      :class="{'open':showFilter, 'closed': !showFilter}"
    >
      <div class="title">
        <h1>Dashboard</h1>

        <div class="tasks--menu">
          <span v-for="(item, key) in menu" :key="key">
            <a
              :href="item.path"
              :class="{'active': activeItem === ('/' + item.path)}"
            >{{ item.title }}</a>
          </span>
        </div>
      </div>
      <div
        ref="sidebar-facets"
        class="sidebar-left"
        :class="{'open':showFilter, 'closed': !showFilter}"
      >
        <div class="facets-title">
          <h1>{{ manageObservationsTitle }}</h1>
        </div>
        <div class="facets-data">
          <div class="search-bar">
            <md-field class="search">
              <label>Search</label>
              <md-icon>search</md-icon>
              <md-input
                @keyup="searchBarTyping = true"
                @keyup.enter="searchBarTyping = false; goSearch()"
                v-model="searchBar"
              ></md-input>
              <md-button
                v-show="searchBarTyping == true"
                @click="searchBarTyping = searchBar == '' ? true : false; goSearch()"
                class="md-button search"
              >
                Search
                <md-icon>arrow_right_alt</md-icon>
              </md-button>
              <md-button
                v-show="searchBarTyping == false"
                @click="searchBarTyping = true; searchBar = ''; clearSearchResult()"
                class="md-icon-button clear"
              >
                <md-icon class="clear">close</md-icon>
              </md-button>
            </md-field>
            <md-button @click="toogleSidebar()" class="filter">
              <md-icon>filter_list</md-icon>
              <span>Filter</span>
              <md-icon class="close" :class="{'active':showFilter}">close</md-icon>
            </md-button>
          </div>
          <div class="other-filters" :class="{'open':showFilter, 'closed': !showFilter}">
            <div class="filters">
              <div class="data" :key="index" v-for="(facet, index) in facets_ordered">
                <div
                  class="facet-wrapper"
                  :key="field"
                  v-for="(item, field) in facet"
                  :class="{'collapsed':collapsed[field]}"
                >
                  <a @click="toggleFilterItem(field)">
                    {{ decorateFacetLabels(field) }}
                    <md-icon>{{ collapsed[field] ? 'expand_less' : 'expand_more'}}</md-icon>
                  </a>
                  <div class="facet" :class="field" v-show="collapsed[field]">
                    <md-checkbox
                      :ref="field + '_' + index"
                      :key="index"
                      v-for="(data, index) in item"
                      @change="updateData(data.url)"
                      v-model="data.values.active"
                      :value="data.values.value"
                    >{{ transformValue(field, data.values.value) }}</md-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="actions">
              <md-button class="clear" v-on:click="clearSearchResult">Reset</md-button>
              <md-button class="md-raised apply" v-on:click="applySearch">Apply</md-button>
            </div>
          </div>
        </div>
      </div>

      <div class="results_count">

        <div class="count">{{ result_count }} Result{{ result_count > 1 ? 's' : ''}}</div>
        <div class="breadcrumbs">
          <div :key="index" v-for="(facet, index) in facets">
            <div class="breadcrumbs-group" :key="field" v-for="(item, field) in facet">
              <div :key="index" v-for="(data, index) in item">
                <div v-if="data.values.active" class="breadcrumb">
                  <span>{{ transformValue(field, data.values.value) }}</span>
                  <md-button class="md-icon-button" @click="removeFacetsAction(data)">
                    <md-icon>close</md-icon>
                  </md-button>
                </div>
              </div>
            </div>
          </div>
          <md-button
            v-if="breadcrumbs.length"
            class="clear"
            v-on:click="clearSearchResult"
          >Clear all</md-button>
        </div>
      </div>
      <div class="result">
        <div class="mobile" v-if="$mq != 'large' && $mq != 'xlarge'">
          <div class="row" :key="i" v-for="(item, i) in filtered" :data-uuid="item.uuid">
            <div class="data-wrapper">
              <div :key="key" v-for="(name, key) in columns" :class="key">
              <span v-if="key === 'submission_learner' && item[key] != ''">
                <span class="title">Learner: </span>
                <span v-html="item[key]"></span>
              </span>
              <span v-else-if="key === 'school' && item[key] != ''">
                <span class="title">Group: </span><span v-html="item[key]"></span>
              </span>
              <span v-else-if="key === 'obs_field_role' && item[key] != ''">
                <span class="title">Role: </span><span v-html="item[key]"></span>
              </span>
              <span v-else-if="key === 'obs_observation' && item[key] != ''">
                <span class="title">Type:</span><span v-html="item[key]"></span>
              </span>
              <span v-else-if="key === 'observation_submission_status' && item[key] != ''">
                <span class="title">Status: </span><span>{{ item[key] }}</span>
              </span>
              <span v-else-if="key === 'date' && item[key] != ''">
                <span class="title">Date: </span><span>{{ item[key] }}</span>
              </span>
              <span v-else v-html="item[key]"></span>
              </div>
            </div>
            <div class="view-more">
              <a :href="getObservationUrl(item['obs_id'])" >View More</a>
            </div>
          </div>
        </div>
        <div class="table" v-else>
          <div class="header">
            <div v-for="(name, key) in columns" :class="key" :key="key">
              <span v-if="key == 'id'">{{ name }}</span>
              <a v-else @click="toggleSort(key)" :class="{'active':sorted[key]}">
                {{ name }}
                <md-icon
                  v-if="key !== 'uuid' "
                >{{ sorted[key] === 'ASC' ? 'arrow_drop_up' : 'arrow_drop_down'}}</md-icon>
              </a>
            </div>
          </div>
          <div class="row" :key="i" v-for="(item, i) in filtered" :data-uuid="item.uuid">
            <div class="data">
              <div :key="key" v-for="(name, key) in columns" :class="key">
                <span v-if="key === 'obs_observation' && item[key] != ''">
                  <span>
                    <a :href="getObservationUrl(item['obs_id'])" >{{ item[key] }}</a>
                  </span>
                </span>
                <span v-else v-html="item[key]"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <paginate
        v-if="pager.total_pages > 1"
        :page-count="pager.total_pages"
        :click-handler="pagerAction"
        :prev-text="''"
        :prev-class="'prev'"
        :next-text="''"
        :next-class="'next'"
        :container-class="'pagination'"
      ></paginate>
      <spinner v-if="showLoader"></spinner>
    </div>
  </div>
</template>

<script>
import MenuMixin from "./MenuMixin";
import Spinner from "./components/Spinner.vue";
import Submissions from "./Submissions";
import Vue from "vue";
import Paginate from "vuejs-paginate";

export default {
  name: "Observations",

  mounted() {
    this.activeItem = window.location.pathname;
  },

  mixins: [Submissions, MenuMixin],

  computed: {
    resultExist() {
      return this.filtered && this.filtered.length > 0;
    },

    menu() {
      let menu = this.getMainMenu(this.$mq)
        .filter((item) => {
          if (item.path == "rubric-submissions") {
            return item;
          }
        });
      if (menu.length) {
        let submenu = menu[0].items.filter((item) => {
          if (item.restricted) {
            return item.access.call();
          } else {
            return true;
          }
        });
        return submenu;
      }
    },

    facets_ordered() {
      var ordering = {}, // map for efficient lookup of sortIndex
        sortOrder = [
          "obs_field_school",
          "obs_field_role",
          "obs_observation",
          "observation_submission_status",
        ];
      for (var i = 0; i < sortOrder.length; i++) {
        ordering[sortOrder[i]] = i;
      }
      return this.facets.sort((a, b) => {
        return (
          ordering[Object.keys(a)[0]] - ordering[Object.keys(b)[0]] ||
          Object.keys(a)[0].localeCompare(Object.keys(b)[0])
        );
      });
    },
  },

  components: {
    Spinner,
    Paginate,
  },

  data() {
    let cols = window.drupalSettings.controller.submissions_settings.columns;
    let sorted = {};
    let keys = Object.keys(cols);
    for (let i = 0; i < keys.length; i++) {
      sorted[keys[i]] = 0;
    }
    return {
      isDataFetched: false,
      collapsed: {},
      lastUrl: "/rest/observations",
      facets: [],
      activeFacets: {},
      pager: [],
      currentPage: 1,
      searchBar: "",
      searchBarTyping: true,
      filtered: [],
      columns: cols,
      sorted: sorted,
      showLoader: false,
      showFilter: false,
      small: false,
      activeItem: false,
      observationLabel: window.drupalSettings.group_catch_config.labels.observation_label,
    };
  },

  watch: {},

  methods: {
    log(msg) {
      console.log(msg);
    },

    getObservationUrl(obsId) {
      return '/observation/' + obsId;
    },
    decorateFacetLabels(field) {
      if (field === "obs_observation") {
        return this.observationLabel;
      } else if (field === "obs_field_school") {
        return "School";
      } else if (field === "observation_submission_status") {
        return "Status";
      } else if (field === "obs_field_role") {
        return "Role";
      } else if (field === "school") {
        return "Group";
      } else {
        return field;
      }
    },

    clearSearchResult() {
      this.searchBar = "";
      this.searchBarTyping = true;
      this.lastUrl = "/rest/observations";
      this.fetchInitialData();
      this.toogleSidebar(0);
    },
    decorateData(data) {
      for (let key in data) {
        let item = data[key];
        if (item.date !== "") {
          item.date = this.$moment.unix(item.date).local().format("MM/DD/YYYY");
          if (item.time !== "") {
            item.date +=
              " " + this.$moment.unix(item.time).local().format("h:mm A");
          }
        }
      }
      return data;
    },
    fetchInitialData() {
      this.showLoader = true;
      let options = {
        headers: {
          Accept: "application/json; odata=verbose",
          "Content-Type": "application/json",
          "cache-control": "no-cache",
        },
        credentials: "include",
        processData: false,
      };
      return fetch("/rest/observations?_format=json", options)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          this.isDataFetched = true;
          this.filtered = this.decorateData(data.search_results);
          this.pager = data.pager;
          this.facets = this.decorateFacets(data.facets);
          this.showLoader = false;
        })
        .catch(() => {
          this.showLoader = false;
        });
    },
    updateData(url) {
      this.showLoader = true;
      this.lastUrl = url;
      fetch(url)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          this.filtered = this.decorateData(data.search_results);

          this.pager = data.pager;
          this.facets = this.decorateFacets(data.facets);
          this.showLoader = false;
          this.currentPage = this.pager.current_page + 1;
        })
        .catch(() => {
          this.showLoader = false;
        });
    },

    getUrlByParams(params) {
      let arr = [];
      for (let [k, v] of Object.entries(params)) {
        if (v) {
          // Sort order must be uppercase
          if (k === "sort_order") {
            v = v.toUpperCase();
          }
          arr.push(k + "=" + v);
        }
      }
      return "/rest/observations?" + arr.join("&");
    },
    transformValue(field, val) {
      return val;
    },
  },
};
</script>

<style lang="scss">
.submissions-app.observation-list {
  .no-data {
    padding: 1rem;
  }

  .result {
    border-radius: 20px;
    background: #ffffff;
    padding: 0px !important;
    font-family: "Source Sans Pro" !important;
    overflow: hidden;
    > div {
      width: 100%;
    }
  }

  .header {
    display: flex;
    font-family: "filson-soft", sans-serif;
    text-transform: uppercase;
    padding: 20px;
    border-bottom: 1px solid rgb(224, 224, 224);

    > div {
      padding-left: 1%;
      padding-right: 1%;
      width: 17%;
      background: transparent !important;
    }
    a {
      display: flex;
      color: rgb(60, 60, 60) !important;
      font-weight: normal !important;
      i {
        font-size: 20px !important;
      }
      &:hover {
        text-decoration: none !important;
        cursor: pointer;
      }
    }
  }

  .row {
    border-bottom: 1px solid rgb(224, 224, 224);
    &.active {
      margin-top: 0px;
      margin-left: 0px;
      margin-bottom: 0px;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.5);
      border-left: 6px solid $blue-dark;
    }
    &.grey {
      background: rgb(245, 245, 245);
    }
    .data {
      display: flex;
      align-items: center;
      padding: 10px;
      > div {
        padding-left: 1%;
        padding-right: 1%;
        width: 17%;
        background: transparent !important;
      }

      .obs_observation {
        a {
          color: $blue-active !important;
          text-transform: capitalize;
        }
      }
    }
  }
}
</style>

